import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useUrlContext } from '../../../contexts/UrlContext';

const LegacyMigrateMobilePart = () => {
  const { t } = useTranslation();

  const { userInfo } = useAuthContext();
  const { redirectToMicrosoftAuth } = useUrlContext();

  const handleConnectClick = () => {
    const email = userInfo?.contact?.email;
    if (!email) return;
    redirectToMicrosoftAuth('b2c', email);
  };

  return (
    <div
      style={{
        width: 390,
        minHeight: 700,
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 24,
        paddingBottom: 24,
      }}
    >
      {/* Fond gris arrondi qui occupe ~98% de l’espace */}
      <div
        style={{
          width: '98%',
          borderRadius: 32,
          backgroundColor: '#F6F8FB',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 40,
          paddingBottom: 48,
        }}
      >
        {/* Cercle "Sécurité du compte" */}
        <img
          src="/images/icone05.svg"
          alt="Réinitialisation du mot de passe"
          style={{ width: 120, height: 120, objectFit: 'contain', marginBottom: 30 }}
        />

        {/* Carte blanche avec le texte + bouton */}
        <div
          style={{
            marginTop: 32,
            width: '80%',
            backgroundColor: '#FFFFFF',
            borderRadius: 24,
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.06)',
            padding: '24px 16px 28px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: '#024D71',
              marginBottom: 16,
            }}
          >
            {t('createPart:title')}
          </div>

          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              color: '#61AFA1',
              marginBottom: 16,
            }}
          >
            {t('createPart:subtitle')}
          </div>

          <div
            style={{
              fontSize: 14,
              color: '#024D71',
              marginBottom: 30,
              fontWeight: 500
            }}
          >
            {t('createPart:content')}
          </div>
          <button
            type="button"
            onClick={handleConnectClick}
            style={{
              padding: '0px 20px',
              minHeight: 27,
              borderRadius: 5,
              backgroundColor: '#FF4D00',
              color: '#FFFFFF',
              border: 'none',
              fontSize: 19,
              fontWeight: 'bold',
              cursor: 'pointer',
              textTransform: 'uppercase',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            {t('createPart:button_text')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegacyMigrateMobilePart;
